import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export function useMilestonesViewModel({ buildTemplateId }) {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [milestones, setMilestones] = useState([]);

  const updateBuildTemplate = (data) =>
    stateManager.run(async () =>
      taskService.buildTemplate.update({
        id: buildTemplateId,
        data,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was updated successfully.`,
          },
        },
      })
    );

  const getMilestones = () => {
    stateManager.run(async () => {
      const response = await taskService.milestones.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setMilestones(response.data);
      }
    });
  };

  return {
    isLoading,
    milestones,
    updateBuildTemplate,
    getMilestones,
  };
}
